app.farmnetControllers.addCustomCode('plantProtectantCoreController', function(
  $scope,
  controller,
  $injector
) {
  'use strict';

  // Define the custom search-and-activation header for plant protectants
  $scope.customHeaderTemplate = require('./plantProtectantCoreCustomHeader.html');

  var $http, $dialog, $timeout, i18nFilter;
  var coreUnitService = $injector.get('coreUnitService'),
    searchService = $injector.get('search.service'),
    plantprotectantService = $injector.get('PlantProtectant'),
    plantProtectantModuleConnector = $injector.get(
      'plantProtectantModuleConnector'
    ),
    originalOptions;

  $injector.invoke([
    '$http',
    '$dialog',
    '$timeout',
    'i18nFilter',
    function(_$http, _$dialog, _$timeout, _i18nFilter) {
      $http = _$http;
      $dialog = _$dialog;
      $timeout = _$timeout;
      i18nFilter = _i18nFilter;
    }
  ]);

  /**
   * Order restrictions by severity/type
   */
  function orderBySeverity(restrictions) {
    // Group all restrictions by type
    var condition = [],
      usage = [],
      tip = [],
      danger = [],
      other = [];

    $.each(restrictions, function(i, res) {
      switch (res.type) {
        case 'CONDITION':
          condition.push(res);
          break;

        case 'USAGE':
          usage.push(res);
          break;

        case 'TIP':
          tip.push(res);
          break;

        case 'DANGER':
          danger.push(res);
          break;

        default:
          other.push(res);
          break;
      }
    });

    // Order by group
    return usage
      .concat(condition)
      .concat(danger)
      .concat(tip)
      .concat(other);
  }

  /**
   * For each restriction type: Remove all headings except the first one
   */
  function removeSubsequentHeadings(restrictions) {
    var merkType = '';
    $.each(restrictions, function(i, res) {
      if (res.type !== merkType) {
        merkType = res.type;
        res.label = enums['PlantProtectantRestrictionTypeEnum'][res.type];
      } else {
        res.label = '';
      }
    });
  }

  function updateStockyardOptions(model) {
    if (model) {
      originalOptions = model.plantProtectant.stockyardDisplayUnitOptions.slice();
    }
  }

  ang.overrideFunction(controller, 'onShowDetails', function(baseFn) {
    // Order all restrictions by type and remove redundant headings
    $scope.details.plantProtectant_sysPlantProtectant_restrictions = orderBySeverity(
      $scope.details.plantProtectant_sysPlantProtectant_restrictions
    );

    removeSubsequentHeadings(
      $scope.details.plantProtectant_sysPlantProtectant_restrictions
    );

    // Do the same for use cases
    if ($scope.details.plantProtectant_sysPlantProtectant_useCases) {
      $.each(
        $scope.details.plantProtectant_sysPlantProtectant_useCases,
        function(key, item) {
          item.restrictions = orderBySeverity(item.restrictions);
          removeSubsequentHeadings(item.restrictions);
        }
      );
    }

    // The reordering should not lead to a save
    controller.markCurrentStateSaved();

    baseFn();
  });

  $scope.$watch('details.plantProtectant.unit', function(newVal, oldVal) {
    if (
      newVal !== oldVal &&
      $scope.details &&
      $scope.details.plantProtectant.id !== null
    ) {
      coreUnitService.updateOptions(
        $scope.details.plantProtectant,
        originalOptions
      );
    }
  });

  ang.overrideFunction(controller, 'addClick', function(baseFn) {
    //Result from wizard
    var data = {
      plantProtectant: {
        id: null,
        scope: 'F',
        unit: 'LIQUID_L',
        stockyardDisplayUnit: 'LIQUID_L'
      },
      plantProtectant_sysPlantProtectant_restrictions: [],
      plantProtectant_sysPlantProtectant_restrictions_removed: [],
      sysPlantProtectant_restrictionsMapping: {}
    };
    baseFn(data);
  });

  ang.overrideFunction(controller, 'onAfterLoad', function(baseFn, model) {
    baseFn(model); //super()

    //store original options (a copy)
    updateStockyardOptions(model);

    //init the stockyard options to the selected unit
    coreUnitService.updateOptions(
      $scope.details.plantProtectant,
      originalOptions
    );
  });

  ang.overrideFunction(controller, 'toSaveModel', function(baseFn, model) {
    model = baseFn(model);

    if (model) {
      // Prevent save if we change these fields
      delete model.plantProtectant.unitOptions;
      delete model.plantProtectant.stockyardDisplayUnitOptions;
    }

    return model;
  });

  ang.overrideFunction(controller, 'delete', function(baseFn, popupAnswer) {
    if (
      popupAnswer == 'ok' &&
      controller.details.plantProtectant &&
      controller.details.plantProtectant.sysPlantProtectant &&
      controller.details.plantProtectant.sysPlantProtectant.id
    ) {
      searchIndex.undoExcludeFromIndex(
        controller.details.plantProtectant.sysPlantProtectant.id
      );
    }

    return baseFn(popupAnswer);
  });

  ang.overrideFunction(controller, 'onItemAdded', function(baseFn, addedItem) {
    searchIndex.excludeFromIndex(addedItem.id);
  });

  /**
   * Overwrites the function 'propertyChanged' of the coreCommonController if called from the plantProtectantCoreController.
   * Sets an array 'dirtyField' into the current plantProtectant and adds the name of the field that was changed in FrontEnd.
   */
  ang.overrideFunction(controller, 'propertyChanged', function(
    baseFn,
    fieldName
  ) {
    var model = controller.details.plantProtectant;
    if (model) {
      if (!model.dirtyFlags) {
        model.dirtyFlags = [];
      }
      model.dirtyFlags.push(fieldName);
    }
    return baseFn(fieldName);
  });

  /**
   * Sets the field 'dirtyFlags' to <null> if existent.
   * The dirtyFlags field can be set to the request object in order to give the backend information about changed form fields
   * in the FrontEnd. See also:
   * 'plantProtectantCoreCustom.ang.overrideFunction(controller, "propertyChanged", function(baseFn, fieldName))'
   */
  ang.overrideFunction(controller, 'resetDirtyFlags', function() {
    var model = controller.details.plantProtectant;
    model.dirtyFlags = null;
  });

  /**
   * Overwrites the function 'handleSaveResponse' of the coreCommonController if called from the plantProtectantCoreController.
   * Clears the 'dirtyField' array after it was sent to the BackEnd.
   */
  ang.overrideFunction(controller, 'handleSaveResponse', function(
    baseFn,
    data,
    sentModel
  ) {
    controller.resetDirtyFlags();
    controller.markCurrentStateSaved();

    return baseFn(data, sentModel);
  });

  var searchIndex = searchService(plantProtectantModuleConnector(), {
    initOnFirstSearch: true,
    sortBy: 'tradeName'
  }).buildIndex({
    fullText: function(sysPlantProtectant) {
      if (sysPlantProtectant.isActivated) {
        //exclude from index output but leave it in there, so if the user removes it, it will
        //be immediately available again (without having to reload the whole list again)
        searchIndex.excludeFromIndex(sysPlantProtectant.id);
      }
      return [
        sysPlantProtectant.tradeName,
        sysPlantProtectant.approvalNumber,
        enums.PlantProtectantScopeEnum[sysPlantProtectant.scope]
      ];
    }
  });
  $scope.search = searchIndex.fullTextSearch;
  $scope.searchSelected = function(selectedItem) {
    controller.doAddByTemplate(selectedItem, {
      doNotRefreshIndexList: true,
      openDetails: true
    });
  };

  /**
   * Rendering search context
   */
  switch (app.credentials.company.countryIsoCode) {
    // intentional fall-through
    case 'DEU':
    case 'POL':
    case 'AUT':
    case 'FRA':
    case 'CHE':
      $scope.showAutoComplete = true;
      break;
    default:
      $scope.showAutoComplete = false;
      break;
  }
  return controller;
});
